import styles from "../../styles/SearchBar.module.css"
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined"
import { useState } from "react"
import { ClickAwayListener, IconButton } from "@mui/material"
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined"

interface SearchBarProps {}

export default function SearchBar() {
  const [isActive, setIsActive] = useState(false)
  const [searchString, setSearchString] = useState("")

  return (
    <ClickAwayListener onClickAway={() => setIsActive(false)}>
      <div
        className={`${styles.container} ${isActive ? styles.isActive : ""}`}
        onClick={() => setIsActive(true)}
      >
        <SearchOutlinedIcon />
        <input
          className={styles.input}
          value={searchString}
          onChange={(e) => setSearchString(e.target.value)}
          onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === "Enter") {
              setIsActive(false)
              e.currentTarget.blur()
            }
          }}
          placeholder="Search..."
        />
        {searchString && (
          <div className={styles.closeButton}>
            <IconButton
              disableFocusRipple
              onClick={(e) => {
                e.stopPropagation()
                setSearchString("")
                setIsActive(false)
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}
